import LocalizedStrings from 'react-localization'
import { getCompanyLabel } from 'tools/companyLabel'

interface ObjectString {
  [index: string]: any
}

const COMPANY_LABEL = getCompanyLabel()

let strings = new LocalizedStrings({
  en: {
    /**
     * Place all the strings here to reuse and to maintain the strings in the application
     */
    CREATE: 'Create',
    EDIT: 'Edit',
    DELETE: 'Delete',
    VIEW: 'View',
    UPDATE: 'Update',
    SAVE: 'Save',
    CLOSE: 'Close',
    STORY_BOOK: 'View Document',
    DEMO_TABLE_COMPONENT: 'Demo Table Component',
    PRIMARY_ACTION: 'Primary Action',
    SECONDARY_ACTION: 'Secondary Action',
    CONTROLLER_LIST: 'List of Controllers',
    INPUT_CONTROLLER: 'Input Field Controller',
    SINGLE_SELECT_CONTROLLER: 'Single Select Controller',
    CHECKBOX_CONTROLLER: 'Checkbox Controller',
    SETTINGS: 'Settings',

    USER_NAME: 'User Name',
    ADDRESS: 'Address',
    STATE: 'State',
    CITY: 'City',
    ZIP: 'Zip',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    MOBILE_NUMBER: 'Mobile Number',
    ROLE: 'Role',
    EMAIL_TEMPLATE: 'Email Template',

    PLEASE_ENTER_A_VALID_EMAIL: 'Please enter a valid email',
    PLEASE_ENTER_A_VALID_EMAIL_LIST:
      'Please enter valid emails separated by commas ',
    EMAIL_ALREADY_ADDED: 'That email has already been added',

    COMPANY: 'Company',
    SESSION_HAS_TIMED_OUT: 'Session has timed out',
    PLEASE_RE_ENTER_YOUR_CREDENTIALS:
      'Please re-enter your credentials to login again.',
    ERROR_BOUNDRY_HEADER: 'We ran into a problem.',
    ERROR_BOUNDRY_BODY:
      'Try to refresh your browser or use your browser back button to go back to the previous page.',
    PAGE_404_TITLE: '404',
    PAGE_404_SUBHEADER: 'This page cannot be found',
    PAGE_404_MESSAGE: `The page you are looking for might have been removed,
         had its name changed, or is temporarily unavailable.`,
    PASSWORD_ERROR_FORMAT:
      'Password must be at least 8 characters, include at least one digit, one capital letter and at least one special character (@, $, !, #).',
    EMAIL_ERROR_FORMAT: 'The email format is not correct.',
    EMAIL_ERROR_FORMAT_LIST: 'One or more of the emails format is not correct.',
    MANUAL_GZC_LENGTH: 'Manual GZC requiere to be a 5-digit number',
    
    MANUAL_GZC: {
      LABEL: 'Manual GZC',
      COUNTRY_LABEL: 'Manual GZC Country',
      BULK_EDIT_TITLE: 'Bulk Edit Manual GZC',
      EDIT_TITLE: 'Edit Manual GZC',
      BULK_EDIT_BUTTON: 'Bulk Edit',
      BULK_EDIT_DESCRIPTION: 'Enter a new Manual GZC value for the selected entries',
      AUTOMATIC_GZC_LABEL: 'Automatic GZC',
      
      VALIDATION: {
        REQUIRED: 'Manual GZC is required',
        USA_FORMAT: 'USA Manual GZC must be a 5-digit number',
        MEXICO_FORMAT: 'Mexico Manual GZC must be a 5-digit number',
        CANADA_FORMAT: 'Canada Manual GZC must be in format A1A or A1A1A1 (e.g., K1A or K1A0B1)',
        INVALID_COUNTRY: 'Invalid country selected',
      },
    },
    LOGIN: 'Login',
    LOGOUT: 'Log Out',
    PROFILE: 'Profile',
    PAGE_UNDER_CONSTRUCTION: 'Page Under Construction',
    READ_BLOG: 'Read Our Blog',
    REVIEW_CHANGELOG: 'Review full changelog',
    EMAIL_ADRESS: 'Email Address',
    EMAIL: 'Email',
    SAFETY_EMAIL: 'Safety Contact Email',
    PASSWORD: 'Password',
    TRUCKER_CLOUD_TITLE:
      'The fastest way to connect ELD data to any application.',
    FORGOT_PASSWORD: 'Forgot Password?',
    RECOVER_PASSWORD: 'Recover Password',
    NEW_PASSWORD: 'New Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    RESET_PASSWORD: 'Reset Password',
    BACKTO_LOGIN: 'Back to Login',
    NOT_REGISTERED: 'Not registered, and ',
    WANT_TO_SEE_DEMO: 'want to see a demo?',
    COMPANY_NAME: 'Company name',
    ADDRESS_1: 'Address 1',
    ADDRESS_2: 'Address 2',
    MENU: {
      DASHBOARD: 'Risk Dashboard',
      CARRIERS: 'Carriers',
      ACCOUNTS: 'My Accounts',
      REPORTING: 'Reporting',
      HELP: 'Help',
      SETTINGS: 'Settings',
      PROFILE: 'Profile',
      FLEET_REPORTING: 'Fleet Reporting',
      CARRIER_DASHBOARD: 'Dashboard',
      EVENTS_FEED: 'Events Feed',
      FLEET_MONITORING: 'Fleet Monitoring',
      FLEETFILE: 'FleetFile',
    },
    ROUTES: {
      LOGIN: '/login',
      LOGIN_SSO: '/login/sso',
      WIDGET: '/tcwidget/*',
      DASHBOARD: '/dashboard/*',
      CARRIERS: '/carriers/*',
      CARRIER_DETAILS: '/details',
      ACCOUNTS: '/accounts/*',
      REPORTING: '/reporting/*',
      EVENTS_FEED: '/events-feed/*',
      FLEET_MONITORING: '/fleet-monitoring/*',
      FLEETFILE: '/fleetfile/*',
      FLEET_REPORTING: '/fleet-reporting',
      CARRIER_DASHBOARD: '/carrier-dashboard',
      SETTINGS: '/settings/*',
      SETTINGS_COMPANY_CONFIG: '/company-config',
      SETTINGS_EMAIL_TEMPLATES: '/email-templates',
      SETTINGS_EMAIL_ACCOUNTS: '/email-accounts',
      SETTINGS_WHITE_LABEL: '/white-label',
      SETTINGS_USERS: '/users',
      SETTINGS_AGENTS: '/agents',
      SETTINGS_TAGS: '/tags',
      SETTINGS_ELD_VISIBILITY: '/telematics-visibility',
      SETTINGS_ROO_EXPORT: '/roo-export-settings',
      CHANGE_PASSWORD: '/password-change',
      PROFILE: '/profile/*',
      COB: '/cob/*',
      COB_DIRECT: '/cob/direct/*',
      COB_INSTALL: '/cob/install/*',
      COB_FV: '/cob/fv/*',
      CURRENT_PATH: '/',
      WILDCARD: '*',
      SETTINGS_COMMUNICATION_CENTER: '/communication-center',
    },
    WIDGET: {
      CODE_TYPES: {
        DOT: 'DOT',
        MC: 'MC',
        SCAC: 'SCAC',
        UUID: 'UUID',
        CUID: 'CUID',
        POLICY_ID: 'Policy ID',
      },
      LABELS: {
        CARRIER_NAME: 'Carrier Name',
        CARRIER_EMAIL: 'Carrier Email',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        AGENT_EMAIL: 'Agent Email',
        BROKER_EMAIL: 'Broker Email',
        EMAIL_CHIPS_HINT: 'Press space or Enter to add each email',
        ONBOARD: 'Onboard',
      },
    },
    CARRIERS: {
      CHANGE_TO_NEW_VIEW: 'Change to new view',
      CARRIERS: 'Carriers',
      INVITE_CARRIERS: 'Invite Carriers',
      MY_CARRIERS: 'My Carriers',
      INVITED_CARRIERS: 'Invited Carriers',
      EDIT_CARRIER: 'Edit Carrier',
      CARRIER_NAME: 'Carrier Name',
      DOT: 'DOT',
      MC: 'MC',
      SCAC: 'SCAC',
      UUID: 'UUID',
      CUID: 'CUID',
      POLICY_ID: 'Policy ID',
      CONFIDENTIAL_EVENTS: 'Confidential',
      CONFIDENTIAL_EVENTS_GUIDANCE:
        'This fleet has confidential events enabled. Reach out to the fleet and ask them to turn the confidential-events setting off.',
      DETAILS_TAB: {
        ASSET_ACTIVITY_SCORING: 'Asset Activity & Scoring',
        SEARCH_AND_FILTER: 'Search and Filter',
        ASSET_STATUS: 'Asset Status',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        ALL_ASSETS: 'All Assets',
        TABLE_CAPTION:
          'Active: assets with a Risk Score within the last 10 days, Inactive: assets with no Risk Score in the last 10 days, All Assets: shows all assets regardless of activity',
      },
      TABS: {
        UBI_SUMMARY: 'UBI Summary',
        NBI_TELEMATICS_SCORE: `${COMPANY_LABEL} Telematics Score`,
        SUMMARY_REPORT: 'Summary Report',
        DETAILS: 'Details',
        HEARTBEAT: 'Heartbeat',
        HEARTBEAT_TRENDS: 'Heartbeat Trends',
        MILEAGE_REPORTING: 'Mileage Reporting',
        LOCATION_REPORTING: 'Location Reporting',
        MILES_BY_ZIP: 'Miles by Zip',
        RADIUS_OF_OPERATION: 'Radius of Operation',
        SAFETY_EVENTS: 'Safety Events',
        DRIVERS: 'Drivers',
        RISK_DECILE: 'Risk Deciles',
        FLEET_HEARTBEAT: 'Fleet Heartbeat',
        FLEET_DETAILS: 'Fleet Details',
        FLEET_MILES_BY_ZIP: 'Fleet Miles By Zip',
      },
      PORTFOLIO_TABS: {
        MILEAGE_REPORTING: 'Portfolio Mileage Reporting',
        LOCATION_REPORTING: 'Portfolio Location Reporting',
        HEARTBEAT: 'Portfolio Heartbeat',
        MILES_BY_ZIP: 'Portfolio Fleets Miles by Zip',
        RISK_DECILE: 'Portfolio Risk Deciles',
      },
      NBTABS: {
        NBI_TELEMATICS_SCORE: `${COMPANY_LABEL} Telematics Score`,
        NB_RADIUS_OF_OPERATION: 'Radius of Operation',
        NB_MILES_BY_ZIP: 'KM by Zip',
        NB_SAFETY_EVENTS: 'Safety Events',
        NB_DETAILS: 'Details',
        NB_DRIVERS: 'Drivers',
        NB_MILEAGE_REPORTING: 'Mileage Reporting',
        NB_LOCATION_REPORTING: 'Location Reporting',
      },
      CHANGE_TO_FLEET_VIEW: 'Change to Fleet View',
      CHANGE_TO_INSURANCE_VIEW: 'Change to Insurer View',
      INSURANCE_VIEW: 'Insurer View',
      FLEET_VIEW: 'Fleet View',
      BREAKDOWN_TABLE: {
        TITLE: 'Safety Events Breakdown',
        SUBTITLE: (timeframe: string) => `Last ${timeframe} Days · Click any row to expand event type detail`,
        BY_VEHICLE: 'By Vehicle',
        BY_DRIVER: 'By Driver',
        COL_VEHICLE: 'Vehicle',
        COL_DRIVER: 'Driver',
        COL_MILES: 'Miles',
        COL_KILOMETERS: 'Kilometers',
        COL_EVENTS: 'Events',
        COL_PER_1K_MI: 'Per 1k mi',
        COL_PER_1K_KM: 'Per 1k km',
        COL_EVENT_COMPOSITION: 'Event Composition',
        LOADING: 'Loading breakdown data...',
        NO_EVENTS: 'No events found',
        NO_EVENTS_HINT: 'Try adjusting the filters or selecting a longer time period.',
        OTHER_LABEL: 'Other',
        PCT_OF_TOTAL: (pct: string) => `${pct}% of total`,
        PER_1K_MI: 'per 1k mi',
        PER_1K_KM: 'per 1k km',
        TREND_LABEL: (timeframe: string) => `Trend = vs. prior ${timeframe} days`,
      },
    },
    CARRIERS_MANAGEMENT: {
      MY_CONNECTED_ACCOUNTS: 'My Connected Accounts',
      INVITE_CARRIER: 'Invite Accounts',
      INVITATION_TITLE: 'Invite an Account',
      PLEASE_ENTER_A_VALID_EMAIL: 'Please enter a valid email for the account',
      CONFIRMATION_DIALOG_TITLE: 'Confirm Account Invitation',
      CONFIRMATION_DIALOG_MESSAGE:
        "This operation will create an invitation link for the motor carrier, and the email you set can't be invited again. Are you sure you want to continue?",
      AGREE_BUTTON_TEXT: 'Agree',
      DISAGREE_BUTTON_TEXT: 'Disagree',
    },
    USER_MANAGEMENT: {
      USER_MANAGEMENT: 'User Management',
      USER: 'User',
      USERS: 'Users',
      CREATE_USER: 'Create User',
      EDIT_USER: 'Edit User',
      USER_INFORMATION: 'User Information',

      TEMPLATE_NAME: 'Template Name',
      TEMPLATE_TYPE: 'Template Type',
      EMAIL_ACCOUNTS: 'Email Accounts',
      CONTENT: 'Content',
    },
    AGENT_MANAGEMENT: {
      AGENT_MANAGEMENT: 'Agent Management',
      AGENT: 'Agent',
      AGENTS: 'Agents',
      CREATE_AGENT: 'Create Agent',
      EDIT_AGENT: 'Edit Agent',
      AGENT_INFORMATION: 'Agent Information',

      TEMPLATE_NAME: 'Template Name',
      TEMPLATE_TYPE: 'Template Type',
      EMAIL_ACCOUNTS: 'Email Accounts',
      CONTENT: 'Content',
      ASSIGN: 'Assign',
      UNASSIGN: 'Unassign',
      AVAILABLE_CARRIERS: 'Available Motor Carriers',
      ASSIGNED_CARRIERS: 'Assigned Motor Carriers',
    },
    TAG_MANAGEMENT: {
      TAG_MANAGEMENT: 'Tag Management',
      TAG: 'Tag',
      TAGS: 'Tags',
      CREATE_TAG: 'Create Tag',
      EDIT_TAG: 'Edit Tag',
      TAG_NAME: 'Tag Name',
      TAG_CATEGORY: 'Category',

      TEMPLATE_NAME: 'Template Name',
      TEMPLATE_TYPE: 'Template Type',
      CONTENT: 'Content',
      ASSIGN: 'Assign',
      UNASSIGN: 'Unassign',
      AVAILABLE_CARRIERS: 'Available Motor Carriers',
      ASSIGNED_CARRIERS: 'Assigned Motor Carriers',
    },
    ELD_VISIBILITY: {
      ELD_VISIBILITY: 'Telematics Visibility',
      ELD: 'Telematics',
      CREATE_ELD: 'Create Telematics',
      EDIT_ELD: 'Edit Telematics',
      ELD_NAME: 'Telematics Name',
      AVAILABLE_ELDS: 'Available Telematics Providers to add',
      ASSIGNED_ELDS: 'Assigned Telematics Providers',
      CONFIGURED_ELDS: 'Configured Telematics Providers',
      ADD_ELD: 'Add',
      ADD_ELD_PROVIDERS: 'Add Telematics Providers',
      REMOVE_SELECTED: 'Remove Selected',
      VISIBLE_ELD_PROVIDERS: 'Visible Telematics Providers',
      REMOVE_ELD_PROVIDER: 'Remove Telematics Provider',
      REMOVE_ELD_PROVIDERS: 'Remove Telematics Providers',
      REMOVE_ELD_PROVIDER_CONFIRMATION:
        'Are you sure you want to remove "{0}" from Telematics Visibility?',
      REMOVE_ELDS_PROVIDER_CONFIRMATION:
        'Are you sure you want to remove {0} Telematics Provider{1} from Telematics Visibility?',
      REMOVE_ELD_PROVIDER_WARNING:
        'Once removed, it will no longer be visible in the system.',
      REMOVE_ELDS_PROVIDER_WARNING:
        'Once removed, they will no longer be visible in the system.',
      CONFIRM_REMOVE: 'Yes, I confirm',
    },
    ROO_EXPORT_SETTINGS: {
      PAGE_TITLE: 'Radius of Operation Export Settings',
      TABLE_TITLE: 'Configured Carriers Export Radius',
      CONFIGURE_CARRIERS: 'Configure Carriers',
      CONFIGURE_RADIUS: 'Configure Radius',
      EDIT_EXPORT_SETTINGS: 'Edit Export Settings',
      SAVE: 'Save',
      CANCEL: 'Cancel',
      REMOVE: 'Remove',
      REMOVE_CONFIRM_TITLE: 'Remove Export Radius Config',
      REMOVE_CONFIRM_BODY: 'Are you sure you want to remove the export radius configuration for "{0}"?',
      REMOVE_BULK_CONFIRM_TITLE: 'Remove Export Radius Configs',
      REMOVE_BULK_CONFIRM_BODY: 'Are you sure you want to remove the export radius configuration for {0} carriers?',
      REMOVE_CONFIRM_WARNING: 'Exports will fall back to UI default values (100, 250, 500, 1000).',
      CONFIRM_REMOVE: 'Yes, I confirm',
      TOOLBAR_HINT: 'Select carriers to configure or remove',
      TOOLBAR_SELECTED_SINGLE: '1 Carrier selected',
      TOOLBAR_SELECTED_PLURAL: '{0} Carriers selected',
      COMPANY_DEFAULTS_BTN: 'Company Defaults',
      COMPANY_DEFAULTS_TITLE: 'Company Default Radius Values',
      COMPANY_DEFAULTS_DESCRIPTION_LINE1: 'Applied to all carriers without individual overrides.',
      COMPANY_DEFAULTS_DESCRIPTION_LINE2: 'Affects dashboards and data exports.',
      CARRIER_EXPORT_DESCRIPTION: 'Overrides the company defaults for this carrier. Affects exports only.',
      CARRIER_EXPORT_DESCRIPTION_PLURAL: 'Overrides the company defaults for these carriers. Affects exports only.',
      RESET_TO_DEFAULTS: 'Reset to Defaults',
      ALL_VALUES_IN: 'All values in',
      DOT_LABEL: 'DOT',
      CUID_LABEL: 'CUID',
      POLICY_ID_LABEL: 'Policy ID',
    },
    CLAIMS_SEARCHING: {
      CARRIER_FOR_CLAIMS: 'Select a Carrier for Claims',
      CARRIERS_SEARCH: 'Search for Carrier',

      SAFETY_EVENTS: 'Safety Events',
      ROUTES: 'Routes',
      SEARCH_SAFETY_LABEL: 'Search for Safety Events',
      NO_SAFETY_LABEL: 'No Safety Events Available',
      NO_SAFETY_TOOLTIP: 'Fleet does not have Safety Events',

      SEARCH: 'Search',
      SEARCH_VEHICLES: 'Search Vehicles',

      START_DATE_LABEL: 'Start Date and Time',
      END_DATE_LABEL: 'End Date and Time',
      END_DATE_ERROR:
        'End Date must be at least 1 minute after the Start Date.',

      SAFETY_EVENTS_CARRIER_LIMIT: 10000,
      SAFETY_EVENTS_PORTFOLIO_LIMIT: 1000,
      SAFETY_EVENTS_ALERT_CONTENT: (limit: string) =>
        `For optimal viewing, only the ${limit} most recent events are displayed. To see other events, try adjusting the filters.`,
      ROUTES_EMPTY_TOAST_MESSAGE: 'No route found for this event',
      ROUTES_SUCCESS_TOAST_MESSAGE: 'Route fetched successfully',
    },
    CLAIMS_DETAILS: {
      EVENT: 'Event',
      ID: 'ID',
      TIME: 'Time',
      SPEED: 'Speed',
      LATITUDE: 'Latitude',
      LONGITUDE: 'Longitude',
      VEHICLE_DETAILS: 'Vehicle Details',
      DRIVER_DETAILS: 'Driver Details',
      GFORCE_DATA: 'G-Force Data',
      CAMERA_POSITION: 'Camera Position',
      NAME: 'Name',
      TYPE: 'Type',
      LICENSE_PLATE: 'License Plate',
      VIN: 'VIN',
      SERIAL_NO: 'Serial Number',
      MAKE: 'Make',
      MODEL: 'Model',
      MODEL_YEAR: 'Year',
      LICENSE_NO: 'License No',
      STATE: 'State',
      PHONE: 'Phone',
      EMAIL: 'Email',
      TIME_LABEL: 'Time',
      VALUE: 'Value',
      VIDEO: 'Video',
      IMAGE: 'Image',
      VIDEO_NOT_AVAILABLE: 'No video available for this event.',
      VIDEO_EXPIRED: 'The video for this event has expired.',
      MEDIA: 'Media',
      MEDIA_NOT_AVAILABLE: 'No media available for this event.',
      MEDIA_EXPIRED: 'The media for this event has expired.',
      NO_GFORCE_DATA: 'No G-Force data available.',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      VIEW_IN_PORTAL:
        'This video is available in the {0} portal, click below to view it.',
      VIEW_IN_EXTERNAL_PORTAL: 'View in the {0} external portal',
    },
    CLAIMS_VIDEO_MODAL: {
      FLEET: 'Fleet',
      TIME: 'Time',
      NO_DATA: 'N/A',
      ASSET: 'Asset ID',
      VIN: 'VIN',
      OPEN_IN_NEW_TAB: 'Open in New Tab',
      CLOSE: 'Close',
      VIEW_IN_PORTAL:
        'This video is available in the {0} portal, click below to view it.',
      VIEW_IN_EXTERNAL_PORTAL: 'View in the {0} external portal',
    },
    CARRIER_HEARTBEAT: {
      DOWNLOAD_TEMPLATE_TOOLTIP: '',
      CSV_TEMPLATE:
        'Identification_No\nEXAMPLEVIN0000000\nEXAMPLEVIN0000001\nEXAMPLEVIN0000002',
    },
    DRIVERS: {
      DRIVERS: 'Drivers',
      ACTIVE_DRIVERS: 'Active Drivers',
      ACTIVE_VEHICLES: 'Active Vehicles',
      ACTIVE_DRIVER_VEHICLE_RATIO: 'Active Driver/Vehicle Ratio',
      AVERAGE_MILES_BY_DRIVER: 'Average Miles by Driver',
      RECENT_TEAM_DRIVING: 'Recent Team Driving',
      VEHICLE_ASSIGNMENTS: 'Vehicle Assignments',
      DRIVER_LIST: 'Driver List',
      VEHICLE_ASSIGNMENTS_DRIVERS_PROPERTY: 'assignedDrivers',
      RECENT_TEAM_DRIVING_DRIVERS_PROPERTY: 'drivers',
    },
    COMPANY_CONFIG: {
      COMPANY_NAME: 'Company Name',
      COMPANY_ID: 'Company ID',
      COMPANY_TYPE: 'Company Type',
      MC: 'MC',
      DOT: 'DOT',
      SCAC: 'SCAC',
      SUPPORT_EMAIL: 'Support Email',
      EMAIL_SUBSCRIPTION: 'Email Subscription',
      ADDRESS: 'Address',
      WEBSITE: 'Website',
      PHONE_NUMBER: 'Phone Number',
    },
    EMAIL_TEMPLATES: {
      EMAIL_TEMPLATES: 'Email Templates',
      NEW_TEMPLATE: 'New Template',
      TEMPLATE_NAME: 'Template Name',
      TEMPLATE_TYPE: 'Template Type',
      EMAIL_ACCOUNTS: 'Email Accounts',
      CONTENT: 'Content',
      EDIT_TEMPLATE: 'Edit Template',
      CREATE_TEMPLATE: 'Create Template',
    },
    EMAIL_ACCOUNTS: {
      EMAIL_ACCOUNTS: 'Email Accounts',
      NEW_ACCOUNT: 'New Account',
      SENDER_NAME: 'Sender Name',
      SENDER_EMAIL: 'Sender Email',
      EDIT_ACCOUNT: 'Edit Account',
      CREATE_ACCOUNT: 'Create Account',
    },
    COMMUNICATION_CENTER: {
      COMMUNICATION_CENTER: 'Communication Center',
      RISK_SCORE_NOTIFICATION_TYPE: 'RISKSCORE',
      DISCONNECTED_CARRIERS_NOTIFICATION_TYPE: 'DISCONNECTED_CARRIERS',
      NOTIFICATION_SETTINGS: 'Notification Settings',
      NOTIFICATION_SETTINGS_UPDATE_SUCCESS:
        'Notification Settings updated successfully',
      NOTIFICATION_SETTINGS_CREATE_SUCCESS:
        'Notification Settings created successfully',
      NEW_CONFIGURATION: 'New Configuration',
      REPORT: 'Report Name',
      COMPANY_NAME: 'Company Name',
      EDIT_CONFIGURATION: 'Edit Configuration',
      CREATE_CONFIGURATION: 'Create Configuration',
      FREQUENCY: 'Frequency',
      USER_MAIL: "Carriers' Notification Email",
      USER_MAIL_CC: 'CC Email',
      CREATE_SETTING: 'Create Setting',
      UPDATE_SETTING: 'Update Setting',
    },
    WHITE_LABEL: {
      WHITE_LABEL: 'White Label',
      INVALID_IMAGE_TYPE:
        'Unsupported file type. Allowed formats: PNG, JPEG, GIF, WebP, ICO, AVIF.',
      IMAGE_TOO_LARGE: 'File is too large. Maximum file size is 1 MB.',
      IMAGE_REQUIREMENTS:
        'Allowed formats: PNG, JPEG, GIF, WebP, ICO, AVIF. Maximum file size: 1 MB.',
    },
    PROFILE_STRING: {
      PROFILE: 'Profile',
      USER_NAME: 'User Name',
      USER_TYPE: 'User Type',
      COMPANY_NAME: 'Company Name',
      EMAIL: 'Email',
      PROFILE_DETAILS: 'Profile Details',
      PASSWORD: 'Password',
      NEW_PASSWORD: 'New Password',
      REQUEST_PASSWORD: 'Request Password Change',
      REQUEST_PASSWORD_INTRO:
        'If you want to change your current password, press the button below and you will receive an email with a link to complete the process.',
      SSO_REQUEST_PASSWORD_MESSAGE:
        'Users with Single Sign-On (SSO) login cannot change their passwords.',
      CONFIRM_PASSWORD: 'Confirm Password',
      CHANGE_PASSWORD: 'Change Password',
      PASSWORD_FORMAT:
        'Password must be at least 8 characters, including at least one digit and at least one special character (that is not a digit or letter).',
    },
    OFFBOARDING: {
      OFFBOARDING: 'Offboard',
      CONFIRMATION_DIALOG_TITLE: 'Confirm Carrier Offboarding',
      CONFIRMATION_DIALOG_MESSAGE:
        "You will no longer be able to access this carrier's information. Are you sure you want to continue?",
      AGREE_BUTTON_TEXT: 'Agree',
      DISAGREE_BUTTON_TEXT: 'Disagree',
    },
    CARRIER_STATUS_CHANGE: {
      TYPES: {
        PAUSE: 'pause',
        RESUME: 'resume',
        OFFBOARD: 'offboard',
        RECONNECT: 'reconnect',
      },

      PAUSE_TITLE: 'Pause Carrier',
      CONFIRMATION_PAUSE_TITLE: 'Confirm Carrier Pause',
      CONFIRMATION_PAUSE_MESSAGE:
        'Are you sure you want to pause pulling data for this carrier? You can resume at any time.',

      RESUME_TITLE: 'Resume Carrier',
      CONFIRMATION_RESUME_TITLE: 'Confirm Carrier Resume',
      CONFIRMATION_RESUME_MESSAGE:
        'Are you sure you want to resume pulling data for this carrier?',

      OFFBOARD_TITLE: 'Offboard Carrier',
      CONFIRMATION_OFFBOARD_TITLE: 'Confirm Carrier Offboard',
      CONFIRMATION_OFFBOARD_MESSAGE:
        'Are you sure you want to offboard this carrier? This action is irreversible.',

      RECONNECT_TITLE: 'Reconnect Carrier',
      CONFIRMATION_RECONNECT_MESSAGE:
        'You can generate a new invitation URL to reconnect the Carrier.',
      RECONNECT_TEXTFIELD_PLACEHOLDER: 'Generated URL will appear here',
      RECONNECT_COPY: 'Copy to clipboard',
      RECONNECT_GENERATE_INVITATION: 'Generate and Send Invitation URL',

      CONFIRM_BUTTON_TEXT: 'Confirm',
      CANCEL_BUTTON_TEXT: 'Cancel',
    },
    FILTERS: {
      TITLE: 'Filter Options',
      DESCRIPTION: 'Configure filters to narrow down your Fleet Data',
      CLEAR_BUTTON: 'Clear Filters',
      FILTERS: 'Filters',

      APPLY_BUTTON: 'Apply Filters',
      CLOSE_BUTTON: 'Close',

      TAGS_LABEL: 'Tags',
      SUB_TAGS_LABEL: 'Sub Tags',
      CREDENTIALS_LABEL: 'Credential Status',
      RISK_LABEL: 'Risk Score',
      TIME_LABEL: 'Time Range',
      UNTAGGED_DEFAULT_ID: '-1',
    },
    CSV_EXPORT: {
      DOWNLOAD_AS_CSV: 'Download as CSV',
      RISK_CSV_EXPORT_NAME: 'RiskDataExport.csv',
      ASSETS_CSV_EXPORT_NAME: 'AssetsDataExport.csv',
      CARRIERS_CSV_EXPORT_NAME: 'MyCarriersExport.csv',
      CARRIER_HEARTBEAT_CSV_EXPORT_NAME: 'CarrierHeartbeatExport.csv',
      CLAIMS_SEARCHING_CSV_EXPORT_NAME: 'EventsFeedExport.csv',
      DRIVER_LIST_CSV_EXPORT_NAME: 'DriverListExport.csv',
      VEHICLE_ASSIGNMENTS_CSV_EXPORT_NAME: 'VehicleAssignmentsExport.csv',
      RECENT_TEAM_DRIVING_CSV_EXPORT_NAME: 'RecentTeamDrivingExport.csv',
    },
    SUMMARY_REPORT: {
      CALCULATED_ON: 'Calculated on: ',
      DAYS_OF_DATA_PRE: 'and contains ',
      DAYS_OF_DATA_POST: ' days worth of data',
      SUMMARY_CARDS: {
        HEADER_KPIS_TITLE: 'Header KPIs',
        ACTIVE_VEHICLES: 'Active Vehicles',
        ON_POLICY: 'On Policy',
        TOTAL_MILES: 'Total Miles',
        AVG_PER_UNIT: 'Avg per Unit',
        RISK_SCORE: 'Risk Score',
        HARSH_EVENTS_INDEX: 'Harsh Events Index',
        SPEEDING_INDEX: 'Speeding Index',
        GEOGRAPHIC_INDEX: 'Geographic Index',
        NATIONAL_AVG: 'National Avg',
        CALCULATED: 'Calculated',
        NO_DATA: 'No data available',
        HELP_TEXT:
          '* For Risk Score, Harsh Events Index, Speeding Index, and Geographic Index, the higher the score the better.',
      },
      ESTIMATED_MILES: {
        ESTIMATED_MILES_TITLE: 'Estimated Miles - Total',
        TOTAL_MILEAGE: 'Total Mileage',
        TOTAL_ESTIMATED_MILES_12_MONTHS: 'Total Estimated Miles (12 Months)',
        ACTIVE_UNITS: 'Active Units',
        AVG_PER_UNIT: 'Avg/Unit',
        DATA_AVAILABILITY_NOTE:
          '* Data available from {DATE} onboarding date. Pre-onboarding months would show N/A.',
        MILES_CALCULATION_NOTE:
          '** Miles are calculated using odometer and GPS miles',
        ESTIMATED_MILES: 'Estimated Miles',
        NO_ESTIMATED_MILEAGE_DATA: 'No estimated mileage data available',
      },
      RADIUS_OF_OPERATION: {
        RADIUS_OF_OPERATION_TITLE: 'Radius of Operation',
        RECENT_VEHICLE_LOCATIONS: 'Recent Vehicle Locations',
        MILES_BY_STATE: 'Miles by State',
        MILES_BY_ZIPCODE: 'Miles by Zipcode',
        TOP_ZIPCODES_BY_ACTIVITY: 'Top Zipcodes by Activity',
        NO_DATA: 'No data available',
        NO_MAPS_API_KEY:
          'There was an error loading the map. Please try refreshing the page.',
        STATE: 'State',
        CITY: 'City',
        COUNTRY: 'Country',
        ZIPCODE: 'Zip Code',
        MILES: 'Miles',
        PERCENTAGE: 'Percentage',
        GARAGING_ZIPCODE_CONFIG: 'Garaging Zip Code',
      },
      ACTIVE_UNITS: {
        ACTIVE_UNITS_TITLE: 'Active Units - Past 90 Days',
        VIN: 'VIN',
        DUP_CHIP: 'DUP',
        YEAR: 'Year',
        MAKE: 'Make',
        GARAGING_ZIPCODE: 'Garaging Zipcode',
        TOTAL_MILES: 'Total Miles (90 days)',
        ACTIVE_DAYS: 'Active Days (90 days)',
        AVG_MILES_DAY: 'Active Avg Miles/Day',
        SAFETY_EVENTS: 'Safety Events',
        TIME_SPEEDING: '% Time Speeding Over 10mph',
        CURRENT_RISK_SCORE: 'Current Risk Score',
        LAST_MONTH_SCORE: 'Last Month Score',
        SCORE_CHANGE: 'Score Change',
        NO_UPDATE_DATE: 'No update date available',
        UPDATED_ON: 'Updated on: ',
        COLOR_CODING_TITLE: 'Color Coding:',
        RED_LEGEND:
          'Red = Below National Average (Score <75, or >10% speeding)',
        GRAY_LEGEND: 'Gray = Above National Average (Good Performance)',
        NO_DATA: 'No active units in the last 90 days',
        EMPTY_VALUE: '—',
        DOWNLOAD_CSV: 'Download table as CSV',
      },
      DATA_COVERAGE: {
        NO_DATA_BEFORE: 'No data before ',
        REPORTING_HISTORY: 'Your reporting history',
        TITLE: 'This report goes back to ',
        SUBTITLE:
          'Need periods from before this report starts? We can retrieve them from your telematics provider. Billed per vehicle, per month.',
        ACTION: 'Get Earlier History',
        BLOCKED: {
          DAILY_RUN_IN_PROGRESS:
            "We're collecting today's data right now, which takes priority. History requests open back up once it finishes.",
          DAILY_QUOTA_REACHED:
            "We've reached today's limit for history retrieval across all carriers. This opens back up tomorrow.",
          ALREADY_REQUESTED_TODAY:
            'This carrier already has a history request today. You can request another one tomorrow.',
          RECENTLY_ONBOARDED:
            'This carrier was onboarded less than 24 hours ago. History requests open back up 24 hours after onboarding.',
          NO_VEHICLES:
            'This carrier has no vehicles connected, so there is no history to retrieve.',
        },
        MODAL: {
          STEP_REVIEW: 'Review',
          STEP_DATES: 'Choose dates',
          REVIEW_TITLE: 'Get more history',
          REVIEW_INTRO_PRE: 'Your report currently covers ',
          REVIEW_INTRO_POST: ' to today.',
          REVIEW_INTRO_TAIL:
            ' We can retrieve earlier periods from your telematics provider and add them to every report on this carrier.',
          DISCLAIMER_PAID: 'This is a paid request.',
          DISCLAIMER_BILLING:
            'This will be billed at $2 per vehicle per month unless you have contracted otherwise with TruckerCloud. If you have questions about the costs and billing model, reach out to your TruckerCloud contact.',
          DISCLAIMER_AVAILABILITY:
            'History is subject to what your telematics provider still holds. If a month comes back with no data, you are not charged for it.',
          DISCLAIMER_PREVIEW:
            "You'll see exactly how much history you're requesting before you confirm.",
          DATES_TITLE: 'Select the history to retrieve',
          FROM: 'From',
          TO: 'To',
          END_FIXED_HINT:
            'Fixed to the day before your report starts, so the history you buy joins the history you already have with no gap in between.',
          DAYS_SELECTED: 'Days selected',
          MONTHS_BILLED: 'Months billed',
          VEHICLES: 'Approximate Vehicle Count',
          VEHICLES_HINT:
            'This is approximate because only active vehicles will be counted towards the additional cost per month.',
          BILLABLE: 'Billable',
          VEHICLE_MONTHS: ' vehicle-months',
          FULL_MONTH: ' full month',
          FULL_MONTHS: ' full months',
          DAYS: ' days',
          DAY: ' day',
          SCOPE_TITLE: 'This retrieval covers historical location and safety events.',
          SCOPE_INTEGRATION:
            "We retrieve whichever of the two each telematics integration makes available, so coverage can differ between this carrier's vehicles.",
          SCOPE_INCLUDED:
            'It fills in Mileage Reporting, Miles by State, Miles by Zip, Radius of Operation and Safety Events for the period you request.',
          SCOPE_EXCLUDED:
            'Risk Score and FleetFile are not part of this iteration and will not be recalculated for the period you request.',
          COST_NOTE:
            'Every vehicle on this carrier is retrieved; the range cannot be narrowed to a subset. Selecting any day in a month bills the full month; months your provider returns no data for are not billed. Billed at $2 per vehicle per month unless you have contracted otherwise with TruckerCloud. Data appears in this report as it arrives.',
          CANCEL: 'Cancel',
          NEXT: 'Choose dates',
          BACK: 'Back',
          CONFIRM: 'Confirm and request',
          ALREADY_IN_REPORT: 'Already in your report',
          AVAILABLE: 'Available to request',
          SELECTED: 'Selected',
          NO_SELECTION: 'Pick the first day of history you need.',
          SUCCESS: 'History request submitted. Data will appear as it arrives.',
          FAILURE: 'The history request could not be submitted.',
        },
      },
    },
    NB_SUMMARY_REPORT: {
      CALCULATED_ON: 'Calculated on: ',
      DAYS_OF_DATA_PRE: 'and contains ',
      DAYS_OF_DATA_POST: ' days worth of data',
      SUMMARY_CARDS: {
        HEADER_KPIS_TITLE: 'Header KPIs',
        ACTIVE_VEHICLES: 'Active Vehicles',
        ON_POLICY: 'On Policy',
        TOTAL_MILES: 'Total Miles',
        AVG_PER_UNIT: 'Avg per Unit',
        RISK_SCORE: 'Risk Score',
        HARSH_EVENTS_INDEX: 'Harsh Events Index',
        SPEEDING_INDEX: 'Speeding Index',
        GEOGRAPHIC_INDEX: 'Geographic Index',
        NATIONAL_AVG: 'National Avg',
        CALCULATED: 'Calculated',
        NO_DATA: 'No data available',
        HELP_TEXT:
          '* For Risk Score, Harsh Events Index, Speeding Index, and Geographic Index, the higher the score the better.',
      },
      ESTIMATED_MILES: {
        ESTIMATED_MILES_TITLE: 'Estimated Miles - Total',
        TOTAL_MILEAGE: 'Total Mileage',
        TOTAL_ESTIMATED_MILES_12_MONTHS: 'Total Estimated Miles (12 Months)',
        ACTIVE_UNITS: 'Active Units',
        AVG_PER_UNIT: 'Avg/Unit',
        DATA_AVAILABILITY_NOTE:
          '* Data available from {DATE} onboarding date. Pre-onboarding months would show N/A.',
        MILES_CALCULATION_NOTE:
          '** Miles are calculated using odometer and GPS miles',
        ESTIMATED_MILES: 'Estimated Miles',
        NO_ESTIMATED_MILEAGE_DATA: 'No estimated mileage data available',
      },
      RADIUS_OF_OPERATION: {
        RADIUS_OF_OPERATION_TITLE: 'Radius of Operation',
        RECENT_VEHICLE_LOCATIONS: 'Recent Vehicle Locations',
        MILES_BY_STATE: 'KM by State/Province',
        MILES_BY_ZIPCODE: 'KM by Zip/Postal Code',
        TOP_ZIPCODES_BY_ACTIVITY: 'Top Zip/Postal Codes by Activity',
        NO_DATA: 'No data available',
        NO_MAPS_API_KEY:
          'There was an error loading the map. Please try refreshing the page.',
        STATE: 'State/Province',
        CITY: 'City',
        COUNTRY: 'Country',
        ZIPCODE: 'Zip/Postal Code',
        MILES: 'Miles',
        PERCENTAGE: 'Percentage',
      },
      ACTIVE_UNITS: {
        ACTIVE_UNITS_TITLE: 'Active Units - Past 90 Days',
        VIN: 'VIN',
        DUP_CHIP: 'DUP',
        YEAR: 'Year',
        MAKE: 'Make',
        GARAGING_ZIPCODE: 'Garaging Zip/Postal Code',
        TOTAL_MILES: 'Total Miles (90 days)',
        ACTIVE_DAYS: 'Active Days (90 days)',
        AVG_MILES_DAY: 'Active Avg Miles/Day',
        SAFETY_EVENTS: 'Safety Events',
        TIME_SPEEDING: '% Time Speeding Over 10mph',
        CURRENT_RISK_SCORE: 'Current Risk Score',
        LAST_MONTH_SCORE: 'Last Month Score',
        SCORE_CHANGE: 'Score Change',
        NO_UPDATE_DATE: 'No update date available',
        UPDATED_ON: 'Updated on: ',
        COLOR_CODING_TITLE: 'Color Coding:',
        RED_LEGEND:
          'Red = Below National Average (Score <75, or >10% speeding)',
        GRAY_LEGEND: 'Gray = Above National Average (Good Performance)',
        NO_DATA: 'No active units in the last 90 days',
        EMPTY_VALUE: '—',
        DOWNLOAD_CSV: 'Download table as CSV',
      },
      PDF_EXPORT: {
        TITLE: (carrierName: string) => `${carrierName} - Summary Report`,
        DEFAULT_TITLE: 'Carrier Summary Report',
        SUBTITLE: (generatedDate: string, generatedTime: string) =>
          `Generated on ${generatedDate} at ${generatedTime}`,
        DISCLAIMER:
          "Disclaimer: This report is based on data provided by third-party telematics and ELD systems and is for informational purposes only. TruckerCloud does not guarantee the completeness or accuracy of the data and is not responsible for any decisions made in reliance upon it. All information is aggregated and processed in accordance with TruckerCloud's Data Access and Use Agreement, with appropriate safeguards to protect carrier and driver privacy. Unauthorized use, disclosure, or distribution of this report or its contents is prohibited.",
      },
    },
    NBI_TELEMATICS: {
      CURRENT_FLEET_METRICS: 'Current Fleet Risk Metrics',
      ACTIVE_VEHICLES: 'Active Vehicles',
      ONBOARDED: 'Onboarded',
      MONTHS_OF_DATA: 'months of data',
      GENERATED_ON: 'Generated on',
      AVG_KM_MONTH: 'Average Kilometers/Month',
      AVG_ACTIVE_VEHICLES_MONTH: 'Average Active Vehicles/Month',
      AVG_KM_MONTH_VEHICLE: 'Avg Kilometers/Month/Vehicle',
      POLICY_COUNT: 'Policy Count',
      AVG_KM_MONTH_POLICY: 'Avg Kilometers/Month/Policy',
      NBI_TELEMATICS_SCORE_SECTION_TITLE: `${COMPANY_LABEL} Telematics Score`,
      CALCULATED_ON: 'Calculated on:',
      CONTAINS: 'Contains',
      DAYS_OF_DATA: 'days worth of data',
      MILEAGE_WEIGHTED_NOTE: 'Note: All indices are calculated based on the mileage-weighted average of the fleet\'s scores over the time period in consideration.',
      NBI_TELEMATICS_SCORE_VALUE: `${COMPANY_LABEL} Telematics Score`,
      OUT_OF_100: '/100',
      WEIGHTED_FORMULA: 'Weighted Formula:',
      WEIGHTED_FORMULA_TEXT: '(Speeding Index × 40%) + (Mileage Index × 40%) + (Geographic Index × 20%)',
      SPEED_INDEX: 'Speed Index',
      MILEAGE_INDEX: 'Mileage Index',
      GEOGRAPHIC_INDEX: 'Geographic Index',
      SPEED_INDEX_DESCRIPTION: 'Reflects speeding incidents, violations, and overall adherence to speed limits across your fleet\'s operations.',
      MILEAGE_INDEX_DESCRIPTION: 'Score based on average kilometers driven per vehicle per month. Lower mileage correlates with better safety outcomes.',
      GEOGRAPHIC_INDEX_DESCRIPTION: 'Score based on operational regions including road conditions, weather patterns, and traffic density across your routes.',
      LOW_RISK: 'Low Risk',
      MEDIUM_RISK: 'Medium Risk',
      HIGH_RISK: 'High Risk',
      VERY_HIGH_RISK: 'Very High Risk',
      KM_SUFFIX: 'km',
      K_SUFFIX: 'K',
      DISCLAIMER_LABEL: 'Disclaimer:',
      DISCLAIMER_TEXT:
        "This report is based on data provided by third-party telematics and ELD systems and is for informational purposes only. TruckerCloud does not guarantee the completeness or accuracy of the data and is not responsible for any decisions made in reliance upon it. All information is aggregated and processed in accordance with TruckerCloud's Data Access and Use Agreement, with appropriate safeguards to protect carrier and driver privacy.",
    },
    UNDERWRITERS_SCORE: {
      ACTIVE_VEHICLES: 'Active Vehicles',
      ONBOARDED: 'Onboarded',
      MONTHS_OF_DATA: 'months of data',
      GENERATED_ON: 'Generated on',
      
      // Header Section
      AVG_KM_MONTH: 'Average Kilometers/Month',
      AVG_ACTIVE_VEHICLES_MONTH: 'Average Active Vehicles/Month',
      AVG_KM_MONTH_VEHICLE: 'Avg Kilometers/Month/Vehicle',
      POLICY_COUNT: 'Policy Count',
      AVG_KM_MONTH_POLICY: 'Avg Kilometers/Month/Policy',
      
      // Initial Fleet Assessment Score
      NBI_TELEMATICS_SCORE_SECTION_TITLE: `${COMPANY_LABEL} Telematics Score`,
      CALCULATED_ON: 'Calculated on:',
      CONTAINS: 'Contains',
      DAYS_OF_DATA: 'days worth of data',
      MILEAGE_WEIGHTED_NOTE: 'Note: All indices are calculated based on the mileage-weighted average of the fleet\'s scores over the time period in consideration.',

      // Initial Score Section (Risk Score)
      NBI_TELEMATICS_SCORE_VALUE: `${COMPANY_LABEL} Telematics Score`,
      OUT_OF_100: '/100',
      WEIGHTED_FORMULA: 'Weighted Formula:',
      WEIGHTED_FORMULA_TEXT: '(Speeding Index × 40%) + (Mileage Index × 40%) + (Geographic Index × 20%)',
      
      // Current Fleet Metrics
      CURRENT_FLEET_METRICS: 'Current Fleet Metrics',
      SPEED_INDEX: 'Speed Index',
      MILEAGE_INDEX: 'Mileage Index',
      GEOGRAPHIC_INDEX: 'Geographic Index',
      NATIONAL_AVG: 'National Avg:',
      
      // Risk Descriptions
      SPEED_INDEX_DESCRIPTION: 'Reflects speeding incidents, violations, and overall adherence to speed limits across your fleet\'s operations.',
      MILEAGE_INDEX_DESCRIPTION: 'Score based on average kilometers driven per vehicle per month. Lower mileage correlates with better safety outcomes.',
      GEOGRAPHIC_INDEX_DESCRIPTION: 'Score based on operational regions including road conditions, weather patterns, and traffic density across your routes.',
      
      // Risk Classifications
      LOW_RISK: 'Low Risk',
      MEDIUM_RISK: 'Medium Risk',
      HIGH_RISK: 'High Risk',
      VERY_HIGH_RISK: 'Very High Risk',
      
      // How Risk Levels Work Section
      HOW_RISK_LEVELS_WORK: 'How Risk Levels Work',
      HIGHER_SCORES_BETTER: '• Higher scores are better',
      HIGHER_SCORES_DESCRIPTION: ' - they indicate superior performance in safety metrics',
      KM_PER_TRUCK_SCORING: '• Kilometers per Truck Scoring:',
      KM_PER_TRUCK_SCORING_VALUES: ' >18,500 km per month = 5 | 14,000-18,500 km per month = 15 | 11,500-14,000 km per month = 25 | 10,000-11,500 km per month = 35 | 9,000-10,000 km per month = 45 | 7,500-9,000 km per month = 55 | 6,500-7,500 km per month = 65 | 5,500-6,500 km per month = 75 | 3,500-5,500 km per month = 85 | <3,500 km per month = 95',
      EACH_METRIC_WEIGHTED: '• Each metric is weighted',
      METRIC_WEIGHTS: ' - Speeding (40%), Kilometers per Truck (40%), Geographic (20%)',
      
      // Units
      KM_SUFFIX: 'km',
      K_SUFFIX: 'K',
    },
    TABLE_DEFAULTS: {
      DASH_VALUE: '\u2014',
      DEFAULT_ROW_HEIGHT: 52,
      DEFAULT_DRIVER_ROW_HEIGHT: 24,
      DEFAULT_ELD_PROVIDER_ROW_HEIGHT: 24,
      DEFAULT_ACTION_HEIGHT: 24,
      DEFAULT_CELL_PADDING: 24,
      NA: 'N/A',
    },
    NB_TABLE_DEFAULTS: {
      DASH_VALUE: '\u2014',
      DEFAULT_ROW_HEIGHT: 52,
      DEFAULT_DRIVER_ROW_HEIGHT: 24,
      DEFAULT_ELD_PROVIDER_ROW_HEIGHT: 24,
      DEFAULT_ACTION_HEIGHT: 24,
      DEFAULT_CELL_PADDING: 24,
      NA: 'N/A',
    },
    NB_CARRIER_DETAILS: {
      CARRIER_STATUS_LABEL: 'Carrier Status: ',
      TRUCKERCLOUD_ONBOARDING_DATE: 'TruckerCloud Onboarding Date:',
      EFFECTIVE_DATE: 'Effective Date:',
      TSP: 'TSP:',
      DOT: 'DOT:',
      US_DOT_PREFIX: ' US DOT ',
      POLICY_ID: 'Policy ID:',
      UNITS_WITH_CAMERAS: 'Units with Cameras:',
      EMPTY_VALUE: '-',
    },
    PDF_EXPORT: {
      DISCLAIMER:
        "Disclaimer: This report is based on data provided by third-party telematics and ELD systems and is for informational purposes only. TruckerCloud does not guarantee the completeness or accuracy of the data and is not responsible for any decisions made in reliance upon it. All information is aggregated and processed in accordance with TruckerCloud's Data Access and Use Agreement, with appropriate safeguards to protect carrier and driver privacy. Unauthorized use, disclosure, or distribution of this report or its contents is prohibited.",
      SUMMARY_REPORT: {
        TITLE: (carrierName: string) => `${carrierName} - Summary Report`,
        DEFAULT_TITLE: 'Carrier Summary Report',
      },
      SAFETY_EVENTS: {
        TITLE: (carrierName: string) => `${carrierName} - Safety Events`,
        DEFAULT_TITLE: 'Safety Events Report',
      },
    },
    CONSOLE_EMBED: {
      REPORT_UNAVAILABLE: 'Something went wrong loading this report. Please contact support if the issue persists.',
      REPORT_DISABLED: "This report isn't enabled.",
    },
    PORTFOLIO_REPORTING: {
      PAGE_TITLE: 'Portfolio Reports',
    },
    FLEETFILE: {
      PAGE_TITLE: 'FleetFile',
      TABS: {
        RISK_SCORE: 'FleetFile Score',
      },
    },
    FLEET_MONITORING: {
      FLEET_MONITORING: 'Fleet Monitoring',
      COMMON: {
        MILES: 'Miles (mi)',
        KILOMETERS: 'Kilometers (km)',
        CRITICAL: 'Critical',
        HIGH: 'High',
        MEDIUM: 'Medium',
        LOW: 'Low',
        SETTINGS: 'Settings',
        SAVE: 'Save',
        OVERRIDE_NOTE_TITLE: 'How overrides & owners work',
        OVERRIDE_NOTE_BODY:
          'On, Off, and Inherit control an alert type’s settings for a fleet. Inherit uses the company default, and On or Off overrides it for that fleet. Owners are handled separately. If a fleet has its own owners for an alert type, those are always used, whatever the On, Off, or Inherit setting. If it doesn’t, the company owners are used instead.',
        USING_DEFAULT: 'Using default',
        OVERRIDE: 'Override',
        RESET_TO_DEFAULT: 'Reset to default',
        PARAM_REQUIRED: 'Required',
        SELECT_PLACEHOLDER: 'Select…',
        SEARCH_PLACEHOLDER: 'Select… (type to search)',
        PARAM_REQUIRED_ERROR: 'This value is required.',
        PARAM_NEEDS_VALUE: 'Enter a value — no default available.',
        PARAM_NUMBER_ERROR: 'Must be a number.',
        PARAM_INTEGER_ERROR: 'Must be a whole number.',
        PARAM_MIN_ERROR: (n: number) => `Must be at least ${n}.`,
        PARAM_MAX_ERROR: (n: number) => `Must be at most ${n}.`,
        PARAM_MIN_DATE_ERROR: (d: string) => `Must be on or after ${d}.`,
        PARAM_MAX_DATE_ERROR: (d: string) => `Must be on or before ${d}.`,
        PARAM_MINLEN_ERROR: (n: number) => `Must be at least ${n} characters.`,
        PARAM_MAXLEN_ERROR: (n: number) => `Must be at most ${n} characters.`,
        PARAM_OPTION_ERROR: 'Choose a valid option.',
        SETTINGS_INCOMPLETE: 'Complete the required settings before saving.',
        DISCLAIMER:
          'Automated TruckerCloud Fleet Monitoring notification generated algorithmically from telematics data. Alerts are advisory only — not confirmed events or recommendations for underwriting, claims, or coverage decisions. Verify independently before acting. TruckerCloud disclaims liability for reliance on this notification.',
        NO_VALIDATION_TYPES: 'No alert types available.',
        BACK: '← Back',
        DISCARD: 'Discard',
        SAVE_CONFIGURATION: 'Save Configuration',
        UNSAVED_CHANGES: 'You have unsaved changes.',
        TYPE_EMAIL_PLACEHOLDER: 'Type an email and press Enter',
        CANCEL: 'Cancel',
        LOADING: 'Loading Fleet Monitoring…',
      },
      PARAMETERS: {
        LAST_UPDATED: 'Last updated on {date}',
        LAST_UPDATED_LABELED: '{label} last updated on {date}',
        INHERITED_TITLE: 'While inheriting, this fleet uses:',
        INHERITED_EMPTY: 'No value available — switch this alert to On to set one.',
      },
      ERRORS: {
        LOAD_FAILED: 'Failed to load Fleet Monitoring.',
        LOAD_ALERT_SETTINGS_FAILED: 'Failed to load Alert Settings.',
        LOAD_FLEETS_FAILED: 'Failed to load fleets.',
        LOAD_ALERTS_FAILED: 'Failed to load alerts.',
        SAVE_FAILED: 'Failed to save.',
        ENROLL_FAILED: 'Failed to enroll. Please try again.',
        UPDATE_ENROLLMENT_FAILED: 'Failed to update enrollment.',
        UPDATE_RECIPIENTS_FAILED: 'Failed to update owners.',
        UPDATE_OVERRIDE_FAILED: 'Failed to update alert override.',
        APPLY_OVERRIDE_FAILED: 'Failed to apply override.',
        ENROLL_FLEET_FAILED: (enrolled: boolean) =>
          `Failed to ${enrolled ? 'unenroll' : 'enroll'} fleet.`,
        UPDATE_ALERT_STATUS_FAILED: 'Failed to update alert status.',
      },
      TOASTS: {
        ENROLLED: 'Fleet Monitoring enrolled.',
        SETTINGS_SAVED: 'Alert Settings saved.',
        FLEET_SETTINGS_SAVED: 'Fleet settings saved successfully.',
        FLEETS_ENROLLMENT_UPDATED: (count: number, enroll: boolean) =>
          `${count} fleet${count === 1 ? '' : 's'} ${enroll ? 'enrolled' : 'unenrolled'}.`,
        OVERRIDE_APPLIED: (count: number) =>
          `Override applied to ${count} fleet${count === 1 ? '' : 's'}.`,
        RECIPIENTS_UPDATED: (count: number) =>
          `Owners updated for ${count} fleet${count === 1 ? '' : 's'}.`,
        ALERT_ACKNOWLEDGED: 'Alert acknowledged.',
        ALERT_RESOLVED: 'Alert resolved.',
        ALERTS_UPDATED: 'Alerts updated.',
      },
      ONBOARDING: {
        INTRO_TITLE: 'Catch fleet issues before your policyholders do.',
        INTRO_SUBTITLE: "Your company isn't enrolled in Fleet Monitoring yet.",
        INTRO_BODY:
          'Fleet Monitoring runs scheduled checks against your fleets and emails your team the moment a fleet loses credentials, a feed goes silent, or mileage exceeds a threshold — so you stop finding out about problems when the policyholder calls you.',
        INTRO_NOTE:
          "Either way, your company gets enrolled and you'll see the app. Skipping just means alerts won't be sent until you finish setup in Alert Settings.",
        SKIP_SETUP: 'Skip setup — configure later',
        CONFIGURE_NOW: 'Configure now',
        CONFIGURE_TITLE: 'Set up Fleet Monitoring',
        CONFIGURE_SUBTITLE:
          'A minimal setup to start receiving alerts. These can all be changed later in Alert Settings.',
        DEFAULT_RECIPIENTS_LABEL: 'DEFAULT OWNERS',
        DEFAULT_RECIPIENTS_HELPER:
          "Where alerts go for any fleet that doesn't have its own owners. Add at least one.",
        DISTANCE_UNIT_LABEL: 'DISTANCE UNIT',
        DISTANCE_UNIT_HELPER:
          'Used for thresholds like mileage — your team will see distances in this unit.',
        ENROLL: 'Enroll in Fleet Monitoring',
      },
      ALERT_SETTINGS: {
        DESCRIPTION:
          "Enable alerts and choose how they're delivered. Fleet-level enrollment and per-fleet alert overrides are managed on the Fleets tab.",
        COMPANY_SETTINGS_TITLE: 'Company settings',
        COMPANY_SETTINGS_SUBTITLE:
          'The defaults that apply across your portfolio. Per-fleet overrides are managed on the Fleets tab.',
        DEFAULT_RECIPIENTS: 'Default owners',
        DEFAULT_RECIPIENTS_HINT: 'Used when a fleet has no custom owners',
        DISTANCE_UNIT: 'Distance unit',
        DISTANCE_UNIT_HINT: 'Used for mileage thresholds',
        DELIVERY_CHANNELS_TITLE: 'Delivery Channels',
        DELIVERY_CHANNELS_SUBTITLE: 'Choose how alerts are delivered.',
        EMAIL_NOTIFICATIONS: 'Email Notifications',
        EMAIL_NOTIFICATIONS_HINT:
          'One email per breaching entity. Off pauses outgoing alerts but keeps the run history.',
        ALERTS_HEADING: (enabled: number, total: number) =>
          `Alerts (${enabled} of ${total} enabled)`,
        ENABLE_ALL: 'Enable all',
        DISABLE_ALL: 'Disable all',
        NOTIFY_ON_RESOLVE: 'Send a recovery email when the alert auto-resolves',
        VALIDATION_OWNERS: 'Owners',
        VALIDATION_OWNERS_HINT: 'Falls back to the default owners if empty',
      },
      FLEETS: {
        DESCRIPTION:
          'Manage which fleets are enrolled in monitoring and override alert behavior per fleet. Unenrolled fleets are skipped; alert overrides take precedence over the portfolio defaults.',
        SETUP_BANNER: {
          SKIPPED:
            "Alerts won't be delivered until you finish setup. Fleets with their own custom owners are unaffected.",
          PAUSED: 'Monitoring is paused — no alerts will be sent.',
          NO_ALERTS_ENABLED:
            'No alert types are enabled. Nothing will fire until you turn at least one on.',
          FINISH_SETUP: 'Finish setup',
          GO_TO_SETTINGS: 'Go to settings',
          ENABLE_ALERTS: 'Enable alerts',
        },
        SEARCH_PLACEHOLDER: 'Search fleets…',
        FILTER_ALL: 'All',
        FILTER_MINE: 'My Fleets',
        FILTER_UNASSIGNED: 'Unassigned',
        FILTER_ENROLLED: 'Enrolled',
        FILTER_UNENROLLED: 'Unenrolled',
        SELECTED_COUNT: (n: number) => `${n} fleet${n === 1 ? '' : 's'} selected`,
        SET_OVERRIDE: 'Set alert override…',
        SET_RECIPIENTS: 'Set owners…',
        ENROLL: 'Enroll',
        UNENROLL: 'Unenroll',
        CLEAR: 'Clear',
        EMPTY_NO_FLEETS: 'No fleets to display.',
        EMPTY_NO_MATCH: 'No fleets match your filters.',
        COLUMN_FLEET: 'Fleet',
        COLUMN_CUID: 'CUID',
        COLUMN_POLICY_ID: 'Policy ID',
        COLUMN_RECIPIENTS: 'Owners',
        COLUMN_ALERTS: 'Alerts',
        COLUMN_STATUS: 'Status',
        STATUS_ENROLLED: 'Enrolled',
        STATUS_NOT_ENROLLED: 'Not enrolled',
        DOT_PREFIX: 'DOT',
        RECIPIENTS_MORE: (n: number) => `+${n} more`,
        YOURS: 'YOURS',
        ADD_ME: '+ Me',
        STAT_ASSIGNED: 'Fleets Assigned',
        STAT_MINE: 'My Fleets',
        STAT_UNASSIGNED: 'Unassigned (using default)',
      },
      FLEET_DETAIL: {
        TAB_OVERRIDES: 'Alert Overrides',
        TAB_RECIPIENTS: 'Owners',
        NOT_ENROLLED_HINT:
          "This fleet isn't enrolled — overrides will apply once it's enrolled.",
        RECIPIENTS_HELPER:
          'Override the default owners per alert type. Leave a list empty to fall back to the company default.',
        RECIPIENTS_PLACEHOLDER:
          'Type an email and press Enter — leave empty to use the default',
        ENROLLMENT_FOOTER:
          'Enrollment controls whether any validations run for this fleet.',
        ENROLL: 'Enroll in monitoring',
        UNENROLL: 'Unenroll',
        MODE_OFF: 'Off',
        MODE_INHERIT: 'Inherit',
        MODE_ON: 'On',
      },
      BULK_OVERRIDE: {
        TITLE: 'Set alert override',
        APPLYING_TO: (count: number) =>
          `Applying to ${count} selected fleet${count === 1 ? '' : 's'}.`,
        VALIDATION_TYPE: 'Alert type',
        MODE_LABEL: 'MODE',
        MODE_INHERIT: 'Inherit — use the company default (recommended for most fleets)',
        MODE_ON: 'Force on — always run this alert, even if disabled company-wide',
        MODE_OFF: 'Force off — never run this alert for these fleets',
        APPLY_TO: (count: number) => `Apply to ${count}`,
      },
      BULK_RECIPIENTS: {
        TITLE: 'Set owners',
        APPLYING_TO: (count: number) =>
          `Applying to ${count} selected fleet${count === 1 ? '' : 's'}.`,
        REPLACE: 'Replace',
        ADD_TO_EXISTING: 'Add to existing',
        CLEAR_ALL: 'Clear all',
        EMAILS_LABEL: 'OWNERS',
        EMAILS_PLACEHOLDER: 'alice@co.com, bob@co.com',
        EMAILS_HELPER: 'Separate with commas, spaces, or newlines.',
        EMAILS_PARSED: (count: number) =>
          `${count} email${count === 1 ? '' : 's'} parsed.`,
        CLEAR_WARNING: 'Selected fleets will revert to the company default owners.',
        APPLY_TO_LABEL: 'APPLY TO',
        APPLY_TO_ALL: 'All alerts',
        APPLY_TO: (count: number) => `Apply to ${count}`,
      },
      ALERT_FEED: {
        TAB: 'Alert Feed',
        SEARCH_PLACEHOLDER: 'Search fleet, VIN, or alert...',
        CARD_CRITICAL: 'Critical',
        CARD_HIGH: 'High',
        CARD_OPEN: 'Open Alerts',
        CARD_RESOLVED_TODAY: 'Resolved Today',
        STATUS_ALL: 'All',
        STATUS_NEW: 'New',
        STATUS_ACKNOWLEDGED: 'Acknowledged',
        STATUS_RESOLVED: 'Resolved',
        PRIORITY_ALL: 'All Priorities',
        CATEGORY_ALL: 'All Categories',
        COL_ALERT_TYPE: 'Alert Type',
        COL_CATEGORY: 'Category',
        COL_SEVERITY: 'Severity',
        COL_STATUS: 'Status',
        COL_DETECTED: 'Detected',
        ACKNOWLEDGE: 'Acknowledge',
        RESOLVE: 'Resolve',
        EMPTY: 'No alerts match the current filters.',
        SELECTED_COUNT: (n: number) => `${n} selected`,
        BULK_ACKNOWLEDGE: 'Acknowledge',
        BULK_RESOLVE: 'Resolve',
        CLEAR_SELECTION: 'Clear',
        BULK_ACK_DISABLED: 'Only new alerts can be acknowledged.',
        BULK_RESOLVE_DISABLED: 'Selected alerts are already resolved.',
      },
    },

    REQUIRE_2FA: 'Require 2FA',
    MOBILE_2FA: 'Mobile 2FA',
    ALLOW_APP_SIGNUP: 'Allow App Sign up',
    CREATE_COMPANY: 'Create company',
    UPDATE_COMPANY: 'Update company',
    DELETE_COMPANY: 'Delete company',
    RECONNECT_CARRIER: 'RECONNECT',
    FLEET_OAUTH_RETURN_FAILED_TITLE: 'We could not finish connecting your ELD',
    FLEET_OAUTH_RETURN_FAILED_MESSAGE: 'Go back to the onboarding page and start the sign-in again. If it keeps failing, contact support@truckercloud.com.',
  },
})

export const addStrings = (obj: object, lang: string = 'en') => {
  const original = strings
  strings.setContent({
    [lang]: mergeDeep(original, obj),
  })
  return strings
}

const isObject = (item: object | string) => {
  return item && typeof item === 'object' && !Array.isArray(item)
}

function mergeDeep(source: ObjectString, target: ObjectString) {
  let output: ObjectString = Object.assign({}, target)
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!(key in target))
          Object.assign(output, {
            [key]: source[key],
          })
        else output[key] = mergeDeep(target[key], source[key])
      } else {
        Object.assign(output, {
          [key]: source[key],
        })
      }
    })
  }
  return output
}

export default strings
